import {
  Tab as AriaTab,
  TabList as AriaTabList,
  TabPanel as AriaTabPanel,
  Tabs as AriaTabs,
  type TabListProps,
  type TabPanelProps,
  type TabProps,
  type TabsProps,
} from "react-aria-components";
import { cx } from "@/lib/cx";

export function Tabs({ className, ...props }: Omit<TabsProps, "className"> & { className?: string }) {
  return <AriaTabs className={cx("flex min-w-0 flex-col", className)} {...props} />;
}

export function TabList<T extends object>({
  className,
  ...props
}: Omit<TabListProps<T>, "className"> & { className?: string }) {
  return (
    <AriaTabList
      className={cx("scroll-thin flex min-w-0 gap-1 overflow-x-auto overflow-y-hidden border-b border-line", className)}
      {...props}
    />
  );
}

export function Tab({ className, ...props }: Omit<TabProps, "className"> & { className?: string }) {
  return (
    <AriaTab
      data-ring="inset"
      className={cx(
        "relative inline-flex h-(--control-h-md) shrink-0 items-center gap-1.5 px-2.5 text-sm font-medium whitespace-nowrap text-fg-muted",
        "transition-colors duration-(--dur-fast) data-hovered:text-fg data-selected:text-fg data-disabled:opacity-50",
        "after:absolute after:inset-x-2 after:-bottom-px after:h-0.5 after:rounded-full after:bg-transparent data-selected:after:bg-accent",
        className,
      )}
      {...props}
    />
  );
}

export function TabPanel({ className, ...props }: Omit<TabPanelProps, "className"> & { className?: string }) {
  return <AriaTabPanel className={cx("pt-3 outline-none", className)} {...props} />;
}
